import { Box, styled } from '@mui/material';

export const Container = styled(Box)({
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
